import React from 'react';
import ContentLayout from 'components/ContentLayout';
import { SiteContent } from 'components/common/styles';
import Unpack from 'components/PrePack/Unpack';

function WarehouseTransfer() {
  return (
    <ContentLayout>
      <SiteContent>
        <Unpack />
      </SiteContent>
    </ContentLayout>
  );
}

export default WarehouseTransfer;
